__turbopack_context__.v({
  "className": "inter_312bcb6f-module__uT8wYG__className",
  "variable": "inter_312bcb6f-module__uT8wYG__variable",
});
